import type { ColumnSpec } from '../types';
import { COLS } from '../mocks/columns';

type Visibility = Record<string, boolean>;

interface Props {
  cols?: ColumnSpec[];
  visible: Visibility;
  setVisible(v: Visibility): void;
}

const BILLING_PRESET = new Set([
  'account', 'template', 'affiliate', 'coachee', 'status',
  'dateInc', 'hours', 'rate', 'feeBudget', 'clientFee',
]);

export function ColumnMenu({ cols = COLS, visible, setVisible }: Props): JSX.Element {
  return (
    <div className="colmenu">
      <div className="hd">Show / hide columns</div>
      <div className="body">
        {cols.map((c) => (
          <label key={c.id} className="item">
            <input
              type="checkbox"
              checked={visible[c.id] !== false}
              disabled={c.frozen}
              onChange={() => setVisible({ ...visible, [c.id]: !(visible[c.id] !== false) })}
            />
            <span style={{ flex: 1 }}>{c.label}</span>
            {c.frozen && (
              <span style={{ fontSize: 10, color: 'var(--mute)', textTransform: 'uppercase', letterSpacing: '0.1em', fontWeight: 600 }}>
                Frozen
              </span>
            )}
          </label>
        ))}
      </div>
      <div className="foot">
        <a className="btn-link" onClick={() => {
          const v: Visibility = {};
          cols.forEach((c) => { v[c.id] = true; });
          setVisible(v);
        }}>Show all</a>
        <a className="btn-link" onClick={() => {
          const v: Visibility = {};
          cols.forEach((c) => { v[c.id] = BILLING_PRESET.has(c.id) || !!c.frozen; });
          setVisible(v);
        }}>Billing only</a>
      </div>
    </div>
  );
}
